export const AXIS_LINE_STYLE = { stroke: 'hsl(var(--border))', strokeWidth: 1 };
export const TICK_LINE_STYLE = { stroke: 'hsl(var(--border))' };
